
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.46 10C19.3614 10.1458 19.3029 10.315 19.2907 10.4906C19.2784 10.6662 19.3126 10.8419 19.39 11C19.6382 11.5793 19.8129 12.1873 19.91 12.81C20.1674 14.4201 19.9267 16.0705 19.22 17.54C19.1342 17.7012 19.0059 17.8358 18.849 17.9292C18.6921 18.0227 18.5126 18.0713 18.33 18.07H5.68C5.49638 18.0704 5.31619 18.0202 5.1592 17.9249C5.0022 17.8297 4.87447 17.6931 4.79 17.53C4.14988 16.2314 3.87414 14.7835 3.99219 13.3406C4.11023 11.8976 4.61762 10.5138 5.46028 9.3365C6.30294 8.15924 7.44928 7.23271 8.77709 6.6557C10.1049 6.07868 11.5644 5.8728 13 6.06C13.7264 6.14538 14.4369 6.33395 15.11 6.62C15.2681 6.69738 15.4438 6.73165 15.6194 6.71936C15.795 6.70707 15.9642 6.64865 16.11 6.55C16.2619 6.44995 16.3836 6.31036 16.462 6.14628C16.5405 5.98219 16.5727 5.79982 16.5552 5.61879C16.5377 5.43776 16.4712 5.26492 16.3628 5.11888C16.2544 4.97285 16.1082 4.85914 15.94 4.79C14.0082 3.96166 11.8645 3.76309 9.81341 4.2225C7.76232 4.68191 5.90815 5.77594 4.51426 7.34919C3.12037 8.92243 2.25765 10.8949 2.04865 12.9864C1.83965 15.0779 2.295 17.182 3.35 19C3.52451 19.3023 3.77509 19.5536 4.07683 19.7291C4.37858 19.9045 4.72098 19.9979 5.07 20H18.92C19.2724 20.0014 19.619 19.9097 19.9245 19.734C20.2301 19.5584 20.4838 19.3052 20.66 19C21.4324 17.6614 21.884 16.1621 21.9794 14.6196C22.0749 13.0772 21.8115 11.5336 21.21 10.11C21.1338 9.94776 21.0154 9.80898 20.8672 9.70818C20.719 9.60738 20.5464 9.54826 20.3676 9.53701C20.1887 9.52577 20.0101 9.56281 19.8504 9.64426C19.6907 9.72571 19.5559 9.84858 19.46 10Z' fill='#323232'/><path d='M10.59 12.59C10.2147 12.9653 10.0039 13.4743 10.0039 14.005C10.0039 14.2678 10.0557 14.528 10.1562 14.7708C10.2568 15.0136 10.4042 15.2342 10.59 15.42C10.7758 15.6058 10.9964 15.7532 11.2392 15.8538C11.482 15.9543 11.7422 16.0061 12.005 16.0061C12.5357 16.0061 13.0447 15.7953 13.42 15.42L19.08 6.92999L10.59 12.59Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-speed`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSpeed

    ```js
    <b-new-b-icon-speed />
    ```
</docs>


